// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`InvoiceItem general snapshot 1`] = `
<div class="invoice-item">
  <div class="image-wrap xs-4 md-12">
    <productinfoimage-stub imagery="[object Object]" primary="backie"></productinfoimage-stub>
  </div>
  <div class="info-wrap xs-8 md-12">
    <div class="xs-10 md-12 lg-12">
      <p class="semi-bold upper xs-f-xsmall max-at-tweak">some-type</p>
      <p class="color-slate xs-f-xsmall max-at-tweak">Product 1</p>
    </div>
    <div class="pill-wrap">
      <pill-stub text="SUBSCRIPTION ADD-ON" data-mr-ass="order-subscription"></pill-stub>
    </div>
  </div>
</div>
`;
